const CloseCross = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17.901" height="17.9" viewBox="0 0 17.901 17.9" {...props} >
            <path id="fa-times" d="M7.04,5.781,5.781,7.04l7.691,7.691L5.781,22.423,7.04,23.682l7.691-7.691,7.691,7.691,1.259-1.259-7.691-7.691L23.682,7.04,22.423,5.781l-7.691,7.691Z" transform="translate(-5.781 -5.781)" fill="currentColor" />
        </svg>

    )
}

export default CloseCross;